import { AppState } from '@/app/data';

export default {
    namespaced: true,

    state: {
        // Elk persoon heeft in de onderstaande array zijn/haar eigen object, in dit object staat omschreven of deze persoon daadwerkelijk
        // aanwezig is ja of de nee. Wanneer een persoon wordt afgevinkt, zal Vue dit laten weten aan de state zodat
        // wanneer een nieuwe naam wordt toegevoegd de aanwezigheid van de desbetreffende persoon kan worden meegenomen.
        persons: [ {
                pID: 0,
                name: 'David',
                surname: 'Wigman',
                presence: true,
                alreadySpoken: false
            },
            {
                pID: 1,
                name: 'Remco',
                infixname: 'van den',
                surname: 'Brink',
                presence: true,
                alreadySpoken: false
            },
            {
                pID: 2,
                name: 'Linna',
                surname: 'Praisa',
                presence: true,
                alreadySpoken: false
            },
            {
                pID: 3,
                name: 'Michel',
                surname: 'Ypma',
                presence: true,
                alreadySpoken: false
            },
            {
                pID: 4,
                name: 'Sebastiaan',
                surname: 'Laurentius',
                presence: true,
                alreadySpoken: false
            },
            {
                pID: 5,
                name: 'Ting',
                surname: 'Yuen',
                presence: true,
                alreadySpoken: false
            },
            {
                pID: 6,
                name: 'Suzanne',
                infixname: 'de',
                surname: 'Jong',
                presence: true,
                alreadySpoken: false
            }
        ],
        storeSpeaker: 0
    },

    getters: {
        getPersons: ( state ) =>
        {
            return state.persons;
        },

        findActiveSpeaker: ( state ) =>
        {
            let foundPerson = state.persons.find( person => person.pID === state.storeSpeaker );

            return foundPerson;
        },

        storeSpeaker: state => state.storeSpeaker
    },

    mutations: {
        addPerson: ( state, pName ) =>
        {
            state.persons.push({
                name: pName,
                presence: true,
                alreadySpoken: false
            });
        },

        togglePresence: ( state, person ) =>
        {
            state.persons.find( statePerson => statePerson.pID === person.pID ).presence = !person.presence;
        },

        deletePerson: ( state, person ) =>
        {
            // If the person has already spoken, we want to prevent a known bug that causes the application to get stuck.
            if( state.persons.find( statePerson => statePerson.pID === person.pID ).alreadySpoken ) { return; }

            state.persons.splice( state.persons.findIndex( statePerson => statePerson.pID === person.pID ), 1 );
        },

        pickRandomSpeaker: ( state, payload ) =>
        {
            state.storeSpeaker = payload;
        },

        finishSpeakerRound: ( state, person ) =>
        {
            state.persons.find( statePerson => statePerson.pID === person.pID ).alreadySpoken = true;
        }
    },

    actions: {
        addPerson: ( context, payload ) => { context.commit( 'addPerson', payload ); },
        togglePresence: ( context, pName ) => { context.commit( 'togglePresence', pName ); },
        deletePerson: ( context, index ) => { context.commit( 'deletePerson', index ); },
        pickRandomSpeaker: ({ state, rootGetters, commit, dispatch }) =>
        {
            let onlyPresentPersons = state.persons.filter( naam => naam.presence === true );
            let nonSpokenPersons = onlyPresentPersons.filter( alGeweest => alGeweest.alreadySpoken === false );

            if( nonSpokenPersons.length === 0 )
            {
                dispatch( 'status/changeStatus', AppState.ENDED, {root: true});
            }

            switch( rootGetters['status/currentStatus'] )
            {
                case AppState.READYTOSTART:
                case AppState.READYFORNEXT:
                    // STATUS: READYFORNEXT
                    dispatch( 'status/changeStatus', AppState.BUSY, {root: true});
                    commit( 'pickRandomSpeaker', nonSpokenPersons[ Math.floor( Math.random() * nonSpokenPersons.length ) ].pID );
                    break;
                case AppState.BUSY:
                    // STATUS: BUSY
                    return;
                case AppState.ENDED:
                    // STATUS: ENDED
                    return;
                default:
                    // ERROR: Something went wrong, returning undefined.
                    console.log( `ERROR: Something didn't go to well, is this right? → ${rootGetters['status/currentStatus']}` );
                    return undefined;
            }
        },
        finishSpeakerRound: ({ state, commit, rootGetters }, person ) =>
        {
            if( rootGetters['status/currentStatus'] === AppState.ENDED )
            {
                return;
            }
            commit( 'finishSpeakerRound', person );
        }
    }
};
